import { Tabs } from "@/components/Elements";
import { usePostViewQuery } from "@/services/modules/post";
import { useMemo } from "react";
import { Events } from "./event";

enum EventTab {
  AllEvents = "All Events",
  MyEvents = "My Events",
}

export const ViewEventScreen = () => {
  usePostViewQuery();

  const tabs = useMemo(
    () => [
      {
        id: EventTab.AllEvents,
        label: EventTab.AllEvents,
        Content: () => <Events />,
      },
      {
        id: EventTab.MyEvents,
        label: EventTab.MyEvents,
        Content: () => <Events getUserPost />,
      },
    ],
    []
  );

  return (
    <div className="flex-1">
      <Tabs tabs={tabs} />
    </div>
  );
};
